export function trimString(string, length) {
    
    if (string.length > length) {
        let dots = '...'
        let trimmedString = string.substring(0,length-3)+dots
        return trimmedString
    } else {
        return string
    }
}